import React from 'react';
import { getSmoothStepPath, BaseEdge } from 'reactflow';

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  source,
  target,
  sourceHandle,
  data,
  selected,
  ...restProps
}) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 12,
  });

  // Determine edge color based on source handle and selection state
  const getEdgeStyle = () => {
    const baseStyle = { stroke: '#b1b1b7', strokeWidth: 2, ...style };
    
    // Check if edge is selected (from either selected prop or data.isSelected)
    const isSelected = selected || data?.isSelected;
    
    if (isSelected) {
      // Dark color when selected (regardless of branch type)
      return { ...baseStyle, stroke: '#19192e', strokeWidth: 4 }; // Dark selection color
    }
    
    // Branch-specific colors when not selected
    if (sourceHandle === 'true') {
      return { ...baseStyle, stroke: '#16a34a', strokeWidth: 3 }; // Dark green for true
    } else if (sourceHandle === 'false') {
      return { ...baseStyle, stroke: '#dc2626', strokeWidth: 3 }; // Dark red for false
    }
    
    return baseStyle; // Default gray for action nodes
  };

  return (
    <BaseEdge path={edgePath} markerEnd={markerEnd} style={getEdgeStyle()} />
  );
} 